export const ActionTypes = {
  SET_MONTHLY_CLOSINGS: "MONTHLY_CLOSING_SET_MONTHLY_CLOSINGS",
  SET_FILTERS: "MONTHLY_CLOSING_SET_FILTERS",
  CLEAR_MONTHLY_CLOSINGS: "MONTHLY_CLOSING_CLEAR_MONTHLY_CLOSINGS",
  RESTORE_INITIAL: "MONTHLY_CLOSING_RESTORE_INITIAL",
};
